module.exports = __webpack_public_path__ + "static/media/filter-icon.6744b2ba.svg";